import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  target?: string;
}

export function LinkArea({ href, children, target, ...divProps }: ILinkAreaProps) {
  return (
    <div {...divProps} className={classNames(styles['container'], divProps.className)}>
      <a href={href} target={target} className={styles['link']}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
